import { isBrowserEnv } from './is_browser'

let FormDataConstructor
if (isBrowserEnv()) {
  FormDataConstructor = FormData
} else {
  FormDataConstructor = require('form-data')
}

export function createFormData () {
  return new FormDataConstructor()
}

export function isFormData (obj) {
  return obj instanceof FormDataConstructor
}
